/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.DALTONISM} parameter
 * @source
 */
var DatltonismOptions;
(function (DatltonismOptions) {
    DatltonismOptions["PROTANOPIA"] = "protanopia";
    DatltonismOptions["DEUTERANOPIA"] = "deuteranopia";
    DatltonismOptions["TRITANOPIA"] = "tritanopia";
    DatltonismOptions["MONOCHROMACY"] = "monochromacy";
    DatltonismOptions["ENHANCE_R"] = "enhance_r";
    DatltonismOptions["ENHANCE_G"] = "enhance_g";
})(DatltonismOptions || (DatltonismOptions = {}));
export { DatltonismOptions };
